{
  "id": 32,
  "location": "paris",
  "difficulty": "normal",
  "moves": 15,
  "kinds": 6,
  "goals": [
    { "type": "mud" },
    { "type": "collect", "kind": "latte", "count": 22 }
  ],
  "stars": [2510, 3430],
  "board": [
    ". . . . . . . .",
    ". . . . . . . .",
    ". x . x . x . x",
    "x . x . x . x .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . ."
  ],
  "calibration": { "runs": 1000, "winRate": 0.83, "movesLeft": 4.4, "closeLosses": 0.076, "target": 0.68 }
}
